export const apiCreate = (): string => '/financial/financialMoviments/'
export const apiList = (id?: string): string =>
  !id
    ? '/financial/financialMoviments/'
    : `/financial/financialMoviments/view/${id}`
export const apiUpdate = (id: string): string =>
  `/financial/financialMoviments/update/${id}`
export const apiDelete = (id: string): string =>
  `/financial/financialMoviments/${id}`
